<template>
  <div class="c-text">
    {{ paragraph }}
  </div>
</template>
<script>
// @ is an alias to /src
export default {
  name: 'Paragraph',
  data() {
    return {
      paragraph: this.dataParagraph ? this.dataParagraph : ''
    };
  },
  props: {
    dataParagraph: String
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/essentials/essentials.scss';
@import './paragraph';
</style>
